import { jsx } from "react/jsx-runtime";
import { LoadingScreen } from "../../TldrawEditor.mjs";
const DefaultLoadingScreen = () => {
  return /* @__PURE__ */ jsx(LoadingScreen, { children: "Connecting..." });
};
export {
  DefaultLoadingScreen
};
//# sourceMappingURL=DefaultLoadingScreen.mjs.map
